export default "__VITE_ASSET__D7Pohe$p__"